import { persistStore } from 'redux-persist'
import store from './store/store';

export default persistStore(store);